import React, { useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useDispatch, useSelector } from "react-redux";
import { saveCustomerType } from "../../../actions/CustomerTypeActions";
import { useNavigate } from 'react-router-dom';
import { saveInsuranceType } from "../../../actions/InsuranceTypeActions";
import { saveClient } from "../../../actions/ClientActions";
import { saveState } from "../../../actions/StateAction";
import { saveVehicleCode } from "../../../actions/VehicleCodeActions";
import { getAllVehicleModel, saveVehicleModel, updateVehicleModel } from "../../../actions/VehicleModelActions";
import Toast from "../../../components/Toast";
import Select from "react-select";
import { getAllVehicleType } from "../../../actions/VehicleTypeActions";
import { getAllVehicleMake } from "../../../actions/VehicleMakeActions";
import { useEffect } from "react";
import { styleSelect } from "../../../constants/customStyles";

function AddVehicleModel(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { editVehicleModel, modalType, getData, currentRowsPerPage, page } = props;

    const [name, setName] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleMake, setVehicleMake] = useState('');

    const save = async () => {
        if (vehicleMake.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                vehicle_make_id: vehicleMake.vehicle_make_id,
            }
            await dispatch(saveVehicleModel(data));
            getAllVehicleMake(page, currentRowsPerPage);
        }
        // window.location.href = ('/vendor');
        setName("");
        setVehicleMake(null);
    }

    useEffect(() => {
            dispatch(getAllVehicleType(null, 9999));
            dispatch(getAllVehicleMake(null, 9999, { status: 1 }));
         }, []);

    const vehicleMaker = useSelector(state => state?.vehicleMaker?.vehicleMakers?.data);
    const vehicleTypes = useSelector(state => state?.vehicleType?.vehicleTypes);

    useEffect(() => {
        if (Object.keys(editVehicleModel).length > 0) {
            setName(editVehicleModel.name);
            setVehicleMake(editVehicleModel.vehicle_make_id ? { vehicle_make_id: editVehicleModel.vehicle_make_id, name: editVehicleModel.vehicle_make?.name } : "");
        }
    }, [editVehicleModel])

    const update = async () => {
        if (vehicleMake.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                vehicle_make_id: vehicleMake.vehicle_make_id,
            }
            await dispatch(updateVehicleModel(data, editVehicleModel.vehicle_model_id));
            getAllVehicleMake(page, currentRowsPerPage);
            // dispatch(getAllState());
        }
        // // window.location.href = ('/state')
        setName("")
        setVehicleMake(null);
    }

    const handleChangeVehicleMake = (e) => {
        setVehicleMake({
            vehicle_make_id: e.vehicle_make_id,
            name: e.name
        });
    }
    const clearName = () => {
        setName('');
        setVehicleMake('');
    };
    return (
        <React.Fragment>
            {/* <!-- BEGIN: Modal Content --> */}
            <div id="add-modal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div class="modal-header">
                            <h2 class="fw-medium fs-base me-auto">{modalType == 'add' ? 'Add' : 'Edit'} Vehicle Model</h2>
                        </div>
                        {/* <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="grid columns-12 gap-6 into-y p-5">
                            <div className="col-12 g-col-6">
                                <label for="crud-form-1" className="form-label">Vehicle Make</label>
                                <Select styles={styleSelect} value={vehicleMake} onChange={(e) => handleChangeVehicleMake(e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_make_id}`} options={vehicleMaker && vehicleMaker.length > 0 ? vehicleMaker : []} />
                            </div>
                            <div className="intro-y g-col-6">
                                <label for="crud-form-1" className="form-label">Vehicle Model</label>
                                <input id="crud-form-1" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control w-full" placeholder={name == "" ? "Enter Name..." : (e) => e.target.value} />
                            </div>
                            {/* <div className="col-12 g-col-6">
                                <label for="crud-form-1" className="form-label">Vehicle Type</label>
                                <Select styles={styleSelect} onChange={(e) => setVehicleType(e.vehicle_type_id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes.length > 0 ? vehicleTypes : []} />
                            </div> */}
                            {/* <div className="mt-3">
                                    <label>Status</label>
                                    <div className="form-check form-switch mt-2">
                                        <input type="checkbox" className="form-check-input"/>
                                    </div>
                                </div> */}
                        </div>
                        {/* <!-- END: Form Layout --> */}
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div class="modal-footer text-end">
                            <div className="text-end">
                                <button type="button" data-bs-dismiss="modal" onClick={clearName} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                {
                                    modalType == 'add' ?
                                        <span>
                                            <button type="button" data-bs-dismiss="modal" onClick={save} className="btn btn-primary w-24 me-1">Save</button>
                                            <button type="button" onClick={save} className="btn btn-primary">Save & Add More</button>
                                        </span>
                                        :
                                        <button type="button" data-bs-dismiss="modal" onClick={update} className="btn btn-primary w-24">Update</button>
                                }
                            </div>
                        </div>
                        {/* <!-- END: Modal Footer --> */}
                    </div>
                </div>
            </div>
            {/* <!-- END: Modal Content --> */}
        </React.Fragment>
    )
}

export default AddVehicleModel;